var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBackWhiteIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 12,
    viewBox: "0 0 7 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8443_4836)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.07885 10.602L0.716614 6.25271C0.664837 6.20093 0.628075 6.14484 0.606329 6.08443C0.584582 6.02403 0.573882 5.95931 0.574227 5.89027C0.574227 5.82123 0.5851 5.75651 0.606847 5.69611C0.628593 5.6357 0.665182 5.57961 0.716614 5.52783L5.07885 1.1656C5.19966 1.04478 5.35068 0.984375 5.5319 0.984375C5.71312 0.984375 5.86845 1.0491 5.99789 1.17854C6.12734 1.30798 6.19206 1.459 6.19206 1.63159C6.19206 1.80418 6.12734 1.9552 5.99789 2.08464L2.19227 5.89027L5.99789 9.6959C6.11871 9.81671 6.17911 9.96566 6.17911 10.1427C6.17911 10.3198 6.11439 10.4729 5.98495 10.602C5.85551 10.7314 5.70449 10.7962 5.5319 10.7962C5.35931 10.7962 5.20829 10.7314 5.07885 10.602Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8443_4836"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6.21327,
    height: 10.3555,
    fill: "white",
    transform: "translate(0.355469 0.710938)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackWhiteIcon);
export default __webpack_public_path__ + "static/media/backWhiteIcon.d5216ee5cfc4b79edd021e548e3cc224.svg";
export { ForwardRef as ReactComponent };